    import Vue from 'vue';

    // 自动注册到全局
    Vue.directive('resize', {
        bind(el, binding) {
          // el为绑定的元素，binding为绑定给指令的对象
          console.log(el, '绑定', binding);
          let width = '', height = '';
  
          function isReize() {
            const style = document.defaultView.getComputedStyle(el);
            if (width !== style.width || height !== style.height) {
              // 关键(这传入的是函数,所以执行此函数)
              binding.value({ width: style.width, height: style.height });
            }
            width = style.width;
            height = style.height;
          }
  
          el.__vueSetInterval__ = setInterval(isReize, 300);
        },
  
        unbind(el) {
          console.log(el, '解绑');
          clearInterval(el.__vueSetInterval__);
        }
      });

    //   import Vue from 'vue';
Vue.directive("scroll", {
  inserted: function(el, bind, vnode) {
    let scrollHeight = el.offsetHeight,
      cb_name = bind.expression, // 绑定的函数名
      cb = vnode.context[cb_name]; 
    el.addEventListener("scroll", async () => {
    		// +1防止高度不够
          if (scrollHeight + el.scrollTop + 1 >= el.firstChild.clientHeight) {
                    try {
                    cb && (await cb()); // 触发绑定的函数
                    } catch (error) {
                    console.log(error);
                    }
                }
                });
            }
});



const handler = (event, binding, vnode) => {
 // event.ctrlKey ||
  if (( event.metaKey) && event.keyCode === 13) {
    vnode.context[binding.expression](event);
  }
}


    Vue.directive('meta-enter', {
      bind(el, binding, vnode) {
        el.addEventListener('keydown', event => handler(event, binding, vnode));
      },

      unbind(el) {
        el.removeEventListener('keydown', event => handler(event, binding, vnode));
      }
    });